import { InvitedNotLoggedStudentData, invitedStudentsApi, useInvitedStudents } from "api/invited-students";
import { PaziaBreadcrumbs } from "components/atoms";
import { PageMain } from "components/molecules";
import { PageRichHeader } from "components/molecules/PageHeader/PageRichHeader";
import { routes } from "consts";
import { PaziaButton } from "components/atoms";
import { TanTableClient, TanTableColumn } from "components/molecules";
import { formatDate } from "utils";
import React, { useState } from "react";
import { useToaster } from "utils";

export const InvitedStudentsPage = (): JSX.Element => {
  const { students, invalidate } = useInvitedStudents();
  const { showError, showSuccess } = useToaster();
  const [processing, setProcessing] = useState(false);
  const [selectedItems, setSelectedItems] = useState<string[]>([]);

  const handleSelectedItems = (selectedItems: string[]) => {
    setSelectedItems([...selectedItems]);
  };

  const cols: TanTableColumn<InvitedNotLoggedStudentData>[] = [
    {
      id: "id",
      accessorKey: "id",
      header: "ID",
      enableColumnFilter: false,
      size: 10,
      cell: (info) => info.getValue(),
    },
    {
      id: "email",
      accessorKey: "email",
      header: "Email",
      size: 300,
      enableColumnFilter: false,
    },
    {
      id: "lastEmailSent",
      hideOnMobile: true,
      accessorKey: "lastEmailSent",
      header: "Ostatnie przypomnienie",
      size: 200,
      enableColumnFilter: false,
      cell: (info) => formatDate(info.getValue<Date>(), true),
    },
    {
      id: "numberOfEmailsSent",
      hideOnMobile: true,
      accessorKey: "numberOfEmailsSent",
      header: "Ilość wysłanych przypomnień",
      size: 100,
      enableColumnFilter: false,
      cell: (info) => info.getValue(),
    },
  ];

  const columns = React.useMemo<TanTableColumn<InvitedNotLoggedStudentData>[]>(() => cols, []);

  const onSendEmail = async () => {
    setProcessing(true);
    try {
      await invitedStudentsApi.sendReminders(selectedItems);
      showSuccess("Email został wysłany");
    } catch (error) {
      console.error(error);
      showError("Wystąpił błąd podczas wysyłania emaila");
    } finally {
      invalidate();
      setProcessing(false);
    }
  };

  return (
    <PageMain>
      <PaziaBreadcrumbs
        segments={[{ title: "Użytkownicy", path: routes.STUDENTS }, { title: "Zaproszenia do systemu" }]}
      />
      <PageRichHeader header="Zaproszeni użytkownicy">
        <div className="flex grow justify-end sm:mt-4">
          <div>
            <PaziaButton
              type="tertiary"
              title="Wyślij mail przypominający"
              onClick={onSendEmail}
              disabled={processing}
            />
          </div>
        </div>
      </PageRichHeader>

      <TanTableClient
        data={students}
        columns={columns}
        pageSize={50}
        onSelectionChange={(x) => handleSelectedItems(x.map((y) => y.toString()))}
      />
    </PageMain>
  );
};
